import React, { useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Checkout from '../../components/checkout/Checkout';
import { resgisterExhibitionInitiate } from '../../redux/actions/exhibition';

import '../paymentForm/payment.css';
import logo from '../../assests/images/logo.png'
import Logo from '../../components/logoHolder/Logo';

const Exhibition = () => {
    const dispatch = useDispatch();

  const [name, setName ] = useState('');
  const [email, setEmail] = useState('');
  const [phonenumber, setPhonenumber] = useState('');
  const [amount, setAmount] = useState('');
  const [selected, setSelected] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(resgisterExhibitionInitiate(name, phonenumber, email, selected, amount))
        setEmail('')
        setAmount('')
        setName('')
        setPhonenumber('')
        setSelected('')
        }

  return (
        <div className='born-again-wrapper-form'>
        <div className="inner-wrapper">
            <div className="header-born-again">
                {/* <h1>Enjoy Nigeria Expo</h1> */}
            <Logo />
            </div>
            <div className="confession-text">
                <p>Book exhibition space</p>
            </div>
            <form className="form-to-fill" onSubmit={handleSubmit}>
                <input 
                type="text"
                className='top-input'
                placeholder='Full Name'
                id='fname'
                name='fname'
                value= {name}
                onChange={(e) => setName(e.target.value)}
                required
                />
                <input 
                type="text"
                className='down-input'
                placeholder='Email'
                id='email'
                name='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                />
                <input type="text"
                className='down-input'
                placeholder='Phone Number'
                id='phone'
                name='phone'
                value= {phonenumber}
                onChange={(e) => setPhonenumber(e.target.value)}
                required
                />
                <input type="number"
                className='down-input'
                placeholder='Amount'
                id='amount'
                name='amount'
                value= {amount}
                onChange={(e) => setAmount(e.target.value)}
                required
                />
                <select
                sx={{ backgroundColor:'red' }}
                name='selection'
                defaultValue={'default'}
                className='selected-input'
                value={selected}
                onChange={(e) => setSelected(e.target.value)}
                >
                    <option value='default'>Please select a space</option>
                    <option value='State Pavilion'>State Pavilion</option>
                    <option value='Taste of Nigeria'>Federal Govt. Ministries/Agencies Booth</option>
                    <option value="Images of Nigeria">Corporate Company Booth</option>
                    <option value="Sounds of Nigeria">MSMEs/Entrepreneur Stand</option>
                </select>
            <Checkout selected={selected} amount={amount} email={email} phone={phonenumber} name={name} logo={logo} />
            </form>
        </div>
    </div>
  )
}

export default Exhibition